import React, { createContext, useState, useContext, useEffect } from 'react';
import { signInWithGoogle, signOutGoogle } from '../config/firebase';
import api, { cotacaoAPI } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) { setLoading(false); return; }
    api.get('/auth/me').then(({ data }) => {
      setUser(data);
      localStorage.setItem('user', JSON.stringify(data));
    }).catch(() => {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      setUser(null);
    }).finally(() => setLoading(false));
  }, []);

  const loginWithGoogle = async () => {
    try {
      // Login com Google via Firebase
      const googleResult = await signInWithGoogle();

      if (!googleResult.success) {
        return {
          success: false,
          error: googleResult.error || 'Erro no login com Google'
        };
      }

      // Enviar token para backend validar e verificar autorizacao
      const response = await cotacaoAPI.loginGoogle(googleResult.token);

      // Salvar token e usuario
      localStorage.setItem('token', response.access_token);
      localStorage.setItem('user', JSON.stringify(response.user));
      setUser(response.user);

      return { success: true };
    } catch (error) {
      console.error('Erro no login:', error);

      // Tratar erro de email nao autorizado
      if (error.response?.status === 403) {
        return {
          success: false,
          error: 'Email nao autorizado. Contate o administrador.'
        };
      }

      return {
        success: false,
        error: error.response?.data?.detail || 'Erro ao fazer login'
      };
    }
  };

  const logout = async () => {
    await signOutGoogle();
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  const isAuthenticated = () => {
    return !!user;
  };

  const isAdmin = () => {
    return user?.is_admin === true;
  };

  return (
    <AuthContext.Provider value={{ user, loginWithGoogle, logout, isAuthenticated, isAdmin, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de um AuthProvider');
  }
  return context;
};
